import { faStethoscope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { PAYMENT_TYPE } from '@/constants/treatability';
import PaymentTypeSection from '@/pages/Treatability/components/PaymentTypeSection';
import { Accordion } from '@/ui/Accordion';
import Heading from '@/ui/components/Heading/Heading';

import type { Props } from './types';

const AvailableServices = ({ services, isInsurance }: Props) => {
  const selfPayServices = services.filter((s) => s.payment_type === PAYMENT_TYPE.SELF_PAY);
  const insuranceServices = services.filter((s) => s.payment_type !== PAYMENT_TYPE.SELF_PAY);
  const hasBothPaymentTypes = selfPayServices.length > 0 && insuranceServices.length > 0;

  if (services.length === 0) {
    return null;
  }

  return (
    <>
      <section className="mb-4">
        <div className="flex items-center mb-2">
          <FontAwesomeIcon icon={faStethoscope} className="mr-1 text-gray-500" />
          <Heading value={3} text="Available Services" />
        </div>
        <p className="text-sm text-gray-500 mb-3">
          {isInsurance
            ? 'Programs this member can enroll in based on their state and insurance.'
            : 'Programs this member can enroll in based on their state.'}
        </p>
        <Accordion>
          <PaymentTypeSection
            paymentType={PAYMENT_TYPE.INSURANCE}
            services={insuranceServices}
            defaultOpen
          />
          {/* Self-pay is the exception rather than the norm, so it stays collapsed
              whenever insurance-covered programs are also on offer. */}
          <PaymentTypeSection
            paymentType={PAYMENT_TYPE.SELF_PAY}
            services={selfPayServices}
            defaultOpen={!hasBothPaymentTypes}
          />
        </Accordion>
      </section>
      <hr className="mb-2" />
    </>
  );
};

export default React.memo(AvailableServices);
